exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home-menu {\n\tmargin-bottom: 2em;\n\ttext-align: center;\n/*\tbackground: #efefef;*/\n\tpadding-top: 2em;\n}\n\n#home-menu > div > h4 {\n\tcolor: #ffb97b;\n\tmargin-bottom: 2em;\n}\n\n#home-menu > div > ul > li {\n    margin-top: 1em;\n    margin-bottom: 1em;\n\tdisplay: inline-block;\n\tfont-size: 11pt;\n\tmargin-left: 4em;\n\tmargin-right: 4em;\n}\n\n#home-menu > div > ul > li:hover {\n    cursor: pointer ;\n}\n\n.menu-item-container {\n\ttext-align: left;\n}\n\n.menu-item-container > h5 {\n\tcolor: #ffb97b;\n\tmargin-bottom: 0.5em;\n}\n\n.menu-subitem-container {\n\tmargin-bottom: 1em;\n}\n/*.thetitle {\n\tfont-weight: 700;\n\tfont-size:32px;\n\tfont-family: \"Fredoka One\";\n\tcolor: gold;\n        text-align:center;\n        padding-bottom:10px;\n}\n\n.subtitle {\n\tfont-family: \"Dosis\";\n\tfont-size: 18px;\n\tfont-style: oblique;\n\t}*/\nh4 {\n      font-size: 18px!important;\n}\n.menu-description {\n    color: #757575!important\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/menu.component.css
// module id = ../../../../../src/app/menu.component.css
// module chunks = main